module.exports = __webpack_public_path__ + "static/logo-e40c96fcdb572c561b38252d003a0333.png";